var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fenaju-dashboard"},[_c('div',{staticClass:"ev2-body"},[_c('div',{staticClass:"content-limit"},[_c('div',{staticClass:"content flex"},[_c('pedidos'),_c('requer-atencao'),_c('resumo')],1),_c('div',{staticClass:"content flex"},[_c('clientes-os')],1),_c('div',{staticClass:"content flex"},[_c('leitor')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }